import React from "react";
import Badge from "./Badge";
import ProgressBar from "./ProgressBar";

type UsageCardProps = {
  title: string;
  amount: string;
  percentage: string;
  progress: number;
  imageSrc?: string;
};

const UsageCard: React.FC<UsageCardProps> = ({
  title,
  amount,
  percentage,
  progress,
  imageSrc,
}) => {
  return (
    <article className="flex flex-col justify-center p-5 mt-6 w-full bg-white rounded-xl border border-solid shadow-sm border-[color:var(--Colors-Border-border-secondary,#EAECF0)] min-w-[216px]">
      <div className="flex gap-6 items-start w-full">
        {imageSrc && (
          <img
            src={imageSrc}
            alt={title}
            className="object-contain shrink-0 w-14 rounded-xl aspect-square"
          />
        )}
        <div className="flex-1 shrink basis-0">
          <div className="w-full text-sm font-medium leading-none text-center whitespace-nowrap">
            <div className="flex gap-10 justify-between items-start w-full">
              <Badge variant="info">{title}</Badge>
              <div className="flex gap-1.5 justify-center items-center w-[110px]">
                <Badge variant="outline">{amount}</Badge>
                <Badge variant="success">{percentage}</Badge>
              </div>
            </div>
          </div>
          <ProgressBar progress={progress} />
        </div>
      </div>
    </article>
  );
};

export default UsageCard;
